import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
} from '@/components/common/skeleton';

const ROW_KEYS = [0, 2, 4] as const;

export const ResourcesSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    <View style={styles.section}>
      <SkeletonBone width={180} height={18} />
      <SkeletonBone width="100%" height={120} borderRadius={12} />
    </View>
    <View style={styles.section}>
      <SkeletonBone width={160} height={18} />
      {ROW_KEYS.map((key) => (
        <View key={key} style={styles.row}>
          <View style={styles.cell}>
            <SkeletonBone width="100%" height={96} borderRadius={12} />
          </View>
          <View style={styles.cell}>
            <SkeletonBone width="100%" height={96} borderRadius={12} />
          </View>
        </View>
      ))}
    </View>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 16,
    paddingTop: 12,
    gap: 24,
  },
  section: {
    gap: 12,
  },
  row: {
    flexDirection: 'row',
    gap: 12,
  },
  cell: {
    flex: 1,
  },
});
